/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 去充值
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  deposit: order.DepositDTO,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/recharge`,
    data: deposit,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
